module.exports = __webpack_public_path__ + "resource/img/image025Dark.b3f1e0c9.png";